import { renderingRule } from '../utils/markdown.plugin.utils.js';

/**
 * Markdown-it will render anchor tags with target attribute set to "_blank":
 *
 * [AMZN](https://amazon.com) => <a href="https://amazon.com" target="_blank">AMZN</a>
 *
 * Links in markdown currently replace the instructions tab, which is confusing for students.
 */
const ExternalizeLinks = renderingRule('link_open', _ref => {
  let {
    origRender,
    tokens,
    idx
  } = _ref;
  const aIndex = tokens[idx].attrIndex('target');
  if (aIndex < 0) {
    // Add new attribute
    tokens[idx].attrPush(['target', '_blank']);
  }
  return origRender();
});
var ExternalizeLinks$1 = [ExternalizeLinks];

export { ExternalizeLinks, ExternalizeLinks$1 as default };
